import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { ConfigProvider, DatePicker, Popover, Collapse, /* message, */ Spin, Tooltip, Button } from 'antd';
import { getQueryVariable } from '@/utils/utils';
import SharedModel from './SharedModel';
import intl from 'react-intl-universal';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './Shared.scss';
import './SharedTableAction.scss';
import { store } from 'Store/store.index';
// import acitonIcon from '@/assets/share/more.svg';
// import acitonIconBlack from '@/assets/share/moreBlack.svg';
import link from './images/SharedTableAction/copy_link_icon.png';
// import Email from './images/SharedTableAction/email.svg'
// import EmailBlack from './images/SharedTableAction/email_black.svg'
import Remove from './images/SharedTableAction/remove_me.png';
// import RemoveBlack from '@/assets/share/RemoveMeBlack.svg';
import Unshared from './images/SharedTableAction/delete_share_icon.png';
// import UnsharedBlack from './images/SharedTableAction/unshared_file_black.svg';
import Delete from './images/SharedTableAction/delete_icon.png';
import Download from './images/SharedTableAction/download_icon.png';
// import DownloadBlack from '@/assets/share/DownloadFileBlack.svg';
import { copyToClipboard, isPhantomOnline } from 'Utils/utils';
// import { UTCTimeToLocale, localeToUTC, UTCTimeFormat } from 'Utils/date';
import {
  VIEW_ACTIVITY,
  UNSHARE_FILE,
  DELETE_SHARED_FILE,
  ADD_DEADLINE,
  ADD_DEADLINE_BY_YOU,
  VIEW_ACTIVITY_BY_YOU,
  COPY_SHARED_LINK,
  COPY_SHARED_LINK_BY_YOU,
  //   DOWNLOAD_FILE,
  VIEW_ACTIVITY_BY_OTHERS,
  COPY_SHARED_LINK_BY_OTHERS,
  REMOVE_ME /* REMOVE_MES */,
} from '../../viewer/ui/constants/event.constants.share';
import {
  ADD_DEADLINE_SUCCESS,
  ADD_DEADLINE_FAILED,
  UNSHARE_FILE_SUCCESS,
  UNSHARE_FILE_FAILED,
  DELETE_SHARED_FILE_SUCCESS,
  DELETE_SHARED_FILE_FAILED,
  REMOVE_ME_SUCCESS,
  REMOVE_ME_FAILED,
  COPY_SHARED_LINK_SUCCESS,
  COPY_SHARED_LINK_FAILED,
  //   DOWNLOAD_FILE_SUCCESS,
  //   DOWNLOAD_FILE_FAILED,
} from 'Components/viewer/ui/constants/user.more.constants';
import WrapEmailAutoComplete from '../../dialogs/ShareDlg/EmailAutoComplete';
import { ADD_MORE_PEOPLE_SUCCESS, ADD_MORE_PEOPLE_FAILED } from 'Components/viewer/ui/constants/user.more.constants';
import { isSharedClound } from '@/api/index';
import { isFromReader } from '@/utils/collaboration-platform-reader';
import { collaborationService } from '@/store/services/index';
import { DingtalkShareAction } from '@/modules/dingtalk/components/DingtalkShare';
import { SHARE_DOC } from 'Components/viewer/ui/constants/other.constants';
moment.locale('zh-cn');
const { Panel } = Collapse;

/*
 params
 @data： Object
    name： String
    sharedTime：String
    deadline： String
 @updateTableList: () => void // Refresh table data
 @icon: imgUrl||base64 // Image path
 @type: String (yours|others) // Share whether the file is yours
 */
export default class SharedTableAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userBgColorList: ['#48D2D4', '#BA91FF', '#FFCA60', '#75D060', '#FF8294'],
      isolateComponent: false,
      notPhantomOnline: false,
      visible: false,
      changeDateVisible: false,
      openDatePicker: false,
      collapseActiveKey: ['1'],
      fileDetails: {
        deadline: '',
        viewedAmount: '',
        userTotal: '',
      },
      datePickerValue: moment(),
      activeList: [],
      logSendData: {
        perPage: 10,
        currentPage: 1,
      },
      logLoading: false,
      logHasMore: true,
      showModel: false,
      modelDateils: {},
      propsData: {},
      popover_zIndex: 999,
      isShow_shareWithEmail: false,
      isLoading: false,
    };
    this.activeRef = null;
    this.containerRef = null;
  }
  async componentDidMount() {
    const notPhantomOnline = !isPhantomOnline();
    const isolateComponent = !this.props.parentCom;

    if (notPhantomOnline) {
      this.setState({
        notPhantomOnline: true,
      });
    }
    if (isolateComponent) {
      this.setState({
        isolateComponent: true,
      });
    }
    if (notPhantomOnline && isolateComponent) {
      setTimeout(async () => {
        // this.setState({ notPhantomOnline: true })
        await store.collaborationStore.getMoreOperationData();
        this.getFileDetails(store.collaborationStore.reviewSessionID).then((data) => {
          const { fileDetails, type, fileLink, cDocID, reviewSessionID } = store.collaborationStore.formetShareData(data);

          this.setState({
            propsData: {
              data: fileDetails,
              type,
              cDocID,
              fileLink,
              reviewSessionID,
            },
          });
          this.getOperandsLog();
        });
      }, 200);
    }
  }
  changeDate = (value) => {
    // const dateTime = localeToUTC(moment(value).format('YYYY-MM-DD HH:mm:ss'));
    this.setDeadline(
      moment(value).format('YYYY-MM-DD HH:mm:ss'),
      // moment(dateTime).format('YYYY-MM-DD HH:mm:ss:000')
    );
    this.changeDateVisibleF(false);
  };
  getBgIndex = (userId, index) => {
    return index % 5;
  };
  closeDatePicker = (e) => {
    e.stopPropagation();
    this.setState({ openDatePicker: false });
  };
  showDatePicker = (e) => {
    e.stopPropagation();
    if (!this.state.openDatePicker) this.setState({ openDatePicker: true });
    let parent = this.props.parentCom;
    if (parent === 'CollaborationHeader') {
      store.userStore.doSendGAEvent({ eventKey: ADD_DEADLINE, label: 'review_mode_upper_right_area' });
    }
    if (parent === 'SharedTable' || parent === 'Thumbnail') {
      store.userStore.doSendGAEvent({ eventKey: ADD_DEADLINE_BY_YOU, label: 'getting_started' });
    }
  };
  disabledDate = (time) => {
    if (!time) {
      return false;
    }
    let currentTime = moment().format('YYYYMMDD');
    time = moment(time).format('YYYYMMDD');
    return time < currentTime;
  };
  disabledDateTime = (date) => {
    let currentObj = moment();
    let checedObj = moment(date);
    let currentHours = currentObj.hour(); //0~23
    let currentMinutes = currentObj.minute(); //0~59
    let currentTime = currentObj.format('YYYYMMDD');
    let checkedTime = checedObj.format('YYYYMMDD');
    let checkedHours = checedObj.hour();

    if (checkedTime && currentTime == checkedTime) {
      if (currentHours !== checkedHours) {
        return {
          disabledHours: () => this.range(0, currentHours - 1),
        };
      }

      return {
        disabledHours: () => this.range(0, currentHours - 1),
        disabledMinutes: () => this.range(0, currentMinutes - 1),
      };
    }
  };
  range = (start, end) => {
    const result = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  };
  saveRef = (container) => {
    this.activeRef = container;
  };
  saveContainerRef = (container) => {
    this.containerRef = container;
  };
  cleanDateTime = () => {
    this.changeDateVisibleF(false);
    let { fileDetails } = this.state;
    let bSetDeadline = true;
    if (this.state.fileDetails && this.state.fileDetails.deadline === '') {
      bSetDeadline = false;
    }

    this.setState({
      fileDetails: Object.assign(fileDetails, { deadline: '' }),
      datePickerValue: moment(),
      openDatePicker: false,
    });
    if (bSetDeadline) this.setDeadline('');
  };
  Collapse = (e) => {
    this.setState({
      collapseActiveKey: e,
      isShow_shareWithEmail: false,
    });

    if (e.length > 0) {
      //展开
      let parent = this.props.parentCom;

      if (parent === 'CollaborationHeader') {
        store.userStore.doSendGAEvent({ eventKey: VIEW_ACTIVITY, label: 'review_mode_upper_right_area' });
      }
      if (parent === 'SharedTable' || parent === 'Thumbnail') {
        if (store.collaborationStore.shareReviewListParams.source == '1') {
          store.userStore.doSendGAEvent({ eventKey: VIEW_ACTIVITY_BY_OTHERS, label: 'getting_started' });
        } else {
          store.userStore.doSendGAEvent({ eventKey: VIEW_ACTIVITY_BY_YOU, label: 'getting_started' });
        }
      }
    }
    setTimeout(() => {
      //以此触发popver 的位置计算 方法
      const { popover_zIndex } = this.state;
      let zIndex;
      if (popover_zIndex != 1050) {
        zIndex = 1050;
      } else {
        zIndex = 1041;
      }
      this.setState({
        popover_zIndex: zIndex,
      });
    }, 0);
  };
  displayEmail = () => {
    if (store.appStore.isDisableButton(SHARE_DOC)) return;
    const { isShow_shareWithEmail } = this.state;
    this.setState({
      isShow_shareWithEmail: !isShow_shareWithEmail,
      collapseActiveKey: [],
    });
  };
  getContent = () => {
    let userEmail;
    let userMobile;
    const {
      openDatePicker,
      logLoading,
      logHasMore,
      fileDetails,
      showModel,
      modelDateils,
      datePickerValue,
      propsData,
      isShow_shareWithEmail,
      isLoading,
      collapseActiveKey,
      isolateComponent,
      notPhantomOnline,
      changeDateVisible,
    } = this.state;
    const { deadline } = fileDetails;
    const props = this.props.type ? this.props : propsData;
    const { data = {}, type } = props;
    const { name, sharedTime, shareState, memberList = [] } = data;
    const emailList = memberList.map((item) => item.email || item.userMobile);
    let isBlack = getQueryVariable('isBlack') == 1;
    const inTeamsApp = store.teamsAppStore.inTeamsApp;
    const { userInfo } = store.collaborationStore;

    // console.log('userInfo');
    // console.log(userInfo);

    if (userInfo) {
      userEmail = userInfo.userEmail || store.userNewStore.userData.email;
      userMobile = userInfo.userMobile || store.userNewStore.userData.tel;
    }

    const fromReader = isFromReader();
    // const hideAddDeadLine = getQueryVariable('hideAddDeadLine') || fromReader;
    // const hideShareWithEmail = getQueryVariable('hideShareWithEmail') || fromReader;
    const hideShareWithEmail = true;
    const hideStopSharing = getQueryVariable('hideStopSharing') || fromReader;
    const { viewedAmount, userTotal } = fileDetails;
    // const participants = intl.get('collaboration.sharedList.SharedTableAction.avtiveText', { commentCount: viewedAmount, memberCount: userTotal });
    // const headTitle = `${intl.get('collaboration.sharedList.SharedTableAction.moreActive')}(${participants})`;
    const headTitle = (
      <>
        <span>活动</span>（{viewedAmount}/{userTotal} 已查看）
      </>
    );

    return (
      <div className={`shardMenuBox ${store.appStore.lng.lang} ${isBlack ? 'blackContainer' : ''}`} onClick={this.closeDatePicker} ref={this.saveRef}>
        <Spin spinning={this.state.logLoading}>
          <div className="titleBox">
            <Tooltip title={name}>
              <h3>{name}</h3>
            </Tooltip>
            <p>
              {intl.get('collaboration.sharedList.SharedTableAction.timeTitle')} {sharedTime}
            </p>
            {/* <p>{intl.get('collaboration.sharedList.SharedTableAction.timeTitle')} {sharedTime ? moment(UTCTimeFormat(sharedTime)).format('YYYY-MM-DD HH:mm:ss') : sharedTime}</p> */}
          </div>
          {type === 'yours' && shareState === 0 && !inTeamsApp && !isSharedClound() && (
            <div className="deadlineBoxParent">
              <div className="deadlineBox">
                {deadline ? <p>截止日期： {deadline}</p> : <p>截止日期： 永久有效</p>}
                {/* {deadline ? `${intl.get('collaboration.sharedList.SharedTableAction.DueBy')} ${UTCTimeToLocale(deadline.substring(0,deadline.length-4), true, '-')}` : <p>{intl.get('collaboration.sharedList.SharedTableAction.AddDeadlineBtn')}</p>} */}

                <Popover
                  overlayClassName="shareTableActionChangeDatePopover"
                  visible={changeDateVisible}
                  onVisibleChange={this.changeDateVisibleF}
                  arrowPointAtCenter
                  autoAdjustOverflow={false}
                  //   getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  content={() => {
                    return (
                      <div className="dateList">
                        <div className={`dateListItem ${deadline ? '' : 'active'}`} onClick={this.cleanDateTime}>
                          <i />
                          永久有效
                        </div>
                        <div onClick={this.showDatePicker} className={`dateListItem ${deadline ? 'active' : ''}`}>
                          <i />
                          自定义有效期
                          <div style={{ opacity: 0, cursor: 'pointer', position: 'absolute' /* left: '-270px' */ }}>
                            <DatePicker
                              className={'moreOperateDatePicker shareDatePicker'}
                              onOk={this.changeDate}
                              open={openDatePicker}
                              showTime={{ format: 'HH:mm' }}
                              value={datePickerValue}
                              // getCalendarContainer={() => document.getElementsByClassName('shardMenuBox')[0]}
                              format={'YYYY-MM-DD HH:mm'}
                              popupStyle={{ left: '-270px' }}
                              showToday={false}
                              disabledDate={this.disabledDate}
                              disabledTime={this.disabledDateTime}
                              onChange={(value) => {
                                this.setState({ datePickerValue: value });
                              }}
                              dropdownClassName="shared-table-action-date-dropdown"
                              renderExtraFooter={() => {
                                return (
                                  <Button type="primary" className="cancel-date-btn" onClick={this.cleanDateTime}>
                                    {deadline
                                      ? intl.get('collaboration.sharedList.SharedTableAction.removeDateTime')
                                      : intl.get('collaboration.sharedList.SharedTableAction.cancelDateTime')}
                                  </Button>
                                );
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  }}
                  trigger="click"
                  placement="bottomRight">
                  <div className="changeDate">
                    修改<i></i>
                  </div>
                </Popover>
              </div>
              {/* {!!deadline && <img className="actionIcon" src={Delete} alt="" onClick={this.cleanDateTime} />} */}
            </div>
          )}
          {type === 'others' && (
            //   && deadline
            <div className="deadlineOthersBox">
              <p>
                {deadline ? <p>截止日期： {deadline}</p> : <p>截止日期： 永久有效</p>}
                {/* {deadline && `${intl.get('collaboration.sharedList.SharedTableAction.DueBy')} ${UTCTimeToLocale(deadline.substring(0,deadline.length-4), true, '-')}`} */}
              </p>
            </div>
          )}
          <div className="avitveBox">
            <Collapse
              activeKey={collapseActiveKey}
              expandIconPosition={'right'}
              onChange={this.Collapse}
              expandIcon={({ isActive }) => <i className={`collapse-icon ${isActive ? 'down' : ''}`} />}>
              <Panel header={headTitle} key="1">
                <ul className="activeContentBox">
                  <InfiniteScroll
                    initialLoad={false}
                    pageStart={1}
                    loadMore={this.loadMore}
                    threshold={100}
                    hasMore={!logLoading && logHasMore}
                    useWindow={false}>
                    {this.getActiveList()}
                  </InfiniteScroll>
                </ul>
              </Panel>
            </Collapse>
          </div>
          {userInfo.token && (
            <ul className="btnBox">
              {hideShareWithEmail ? null : (
                <>
                  {shareState === 0 && type === 'yours' && !isSharedClound() && (
                    <li>
                      <div className="shareWithEmail" onClick={this.displayEmail}>
                        <img className="actionIcon" src={isBlack ? EmailBlack : store.userNewStore.userData.email} alt="" />
                        <p>{intl.get('collaboration.sharedList.SharedTableAction.ShareEmail')}</p>
                      </div>
                      {isShow_shareWithEmail && (
                        <WrapEmailAutoComplete
                          docProhibitComment={this.props.docProhibitComment}
                          memberList={memberList}
                          send={this.add}
                          loading={isLoading}
                          changeAllowComment={() => {
                            console.log('changeAllowComment');
                          }}></WrapEmailAutoComplete>
                      )}
                      {isShow_shareWithEmail && <div className="line"></div>}
                    </li>
                  )}
                </>
              )}
              {shareState === 0 && type === 'yours' && !isSharedClound() && (
                <DingtalkShareAction
                  inviteData={this.getInviteParams(true)}
                  onSuccess={this.addSuccess}
                  closeMainArea={isShow_shareWithEmail}
                  onShow={() => this.setState({ isShow_shareWithEmail: false })}
                />
              )}
              {shareState === 0 && !isSharedClound() && (
                <li onClick={this.copyLink}>
                  <img className="actionIcon" src={isBlack ? linkBlack : link} alt="" />
                  <p>复制共享链接</p>
                </li>
              )}
              {(shareState === 1 || isSharedClound()) && (
                <li onClick={this.downloadFile}>
                  <img className="actionIcon" src={Download} alt="" />
                  <p>下载文件</p>
                </li>
              )}
              {(shareState === 0 || isSharedClound()) && type === 'others' && emailList.includes(userEmail || userMobile) && !inTeamsApp && (
                <li
                  onClick={() => {
                    this.showModel('RemoveMe');
                  }}>
                  <img className="actionIcon" src={Remove} alt="" />
                  <p>移除我</p>
                </li>
              )}
              {hideStopSharing ? null : (
                <>
                  {shareState === 0 && type === 'yours' && !inTeamsApp && !isSharedClound() && (
                    <li
                      onClick={() => {
                        this.showModel('Unshared');
                      }}>
                      <img className="actionIcon" src={Unshared} alt="" />
                      <p>取消共享</p>
                    </li>
                  )}
                  {/* </>} */}

                  {shareState === 1 && !isSharedClound() && type === 'others' && emailList.includes(userEmail || userMobile) && !inTeamsApp && (
                    <li
                      onClick={() => {
                        this.showModel('UnsharedDeleteFile');
                      }}>
                      <img className="actionIcon" src={Delete} alt="" />
                      <p>删除文件</p>
                    </li>
                  )}
                  {(shareState === 1 || isSharedClound()) && type === 'yours' && !inTeamsApp && (
                    <li
                      onClick={() => {
                        this.showModel('Delete');
                      }}>
                      <img className="actionIcon" src={Delete} alt="" />
                      <p>删除文件</p>
                    </li>
                  )}
                </>
              )}
            </ul>
          )}
          <SharedModel
            visible={showModel}
            detailsData={modelDateils}
            saveRef={this.activeRef}
            className={isolateComponent && notPhantomOnline ? 'phantom-isolate' : ''}
          />
        </Spin>
      </div>
    );
  };

  getActiveIcon = () => {
    const { fileDetails } = this.state;
    const { viewedAmount, userTotal } = fileDetails;
    return (
      <div className="activeIconBox">
        <p>{intl.get('collaboration.sharedList.SharedTableAction.avtiveText', { commentCount: viewedAmount, memberCount: userTotal })}</p>
        <span className="activeIcon"> &gt; </span>
      </div>
    );
  };
  getActiveList = () => {
    const { activeList } = this.state;
    const getActionName = (item) => {
      let res;

      switch (item.type) {
        case 1:
          res = intl.get('collaboration.sharedList.SharedTableAction.CommentedFile');
          break;
        case 2:
          res = intl.get('collaboration.sharedList.SharedTableAction.CreatedFile');
          break;
        case 3:
          res = intl.get('collaboration.sharedList.SharedTableAction.NotOpenedFile');
          break;
        case 4:
          res = intl.get('collaboration.sharedList.SharedTableAction.OpenedFile');
          break;
        default:
          res = '';
      }

      return res;
    };

    return activeList.map((item, index) => {
      const background = this.state.userBgColorList[this.getBgIndex(item.cUserID, index)];

      return (
        <li className="acitveItemBox" key={index}>
          <div className="portrait-wrapper">
            <div className="defaultPortrait" style={{ background }}>
              {item.name ? item.name[0].toUpperCase() : item.email ? item.email[0].toUpperCase() : 'G'}
            </div>
          </div>
          <div className="detail-wrapper">
            <p className="user-name">{item.email || item.name}</p>
            <p className="action-detail">
              <span>{getActionName(item)}</span>
              <span className="activeDate">
                {item.createDate}
                {/* {item.type !== 3 && moment(UTCTimeToLocale(item.createDate)).format('YYYY-MM-DD HH:mm:ss')} */}
              </span>
            </p>
          </div>
        </li>
      );
    });
  };
  closePop = (visible) => {
    if (!visible) {
      this.setState({ openDatePicker: false, showModel: false });
    } else {
      this.getFileDetails().then(() => {
        this.getOperandsLog();
      });
    }
    this.setState({ visible });
  };
  changeDateVisibleF = (visible) => {
    this.setState({ changeDateVisible: visible });
  };
  getFileDetails = (id) => {
    const { data = {} } = this.props;
    const reviewSessionID = data.reviewSessionID || id;
    const sendData = { reviewSessionID, getMore: 1 };
    return new Promise((resolve) => {
      console.log('协作 1');
      store.collaborationStore.getShareReview(sendData).then((res) => {
        const { ret, data = [] } = res;
        if (ret === 0) {
          const memberList = data[0].memberList || [];
          this.setState({
            fileDetails: {
              deadline: data[0].deadline,
              viewedAmount: data[0].viewedAmount,
              userTotal: memberList.length,
            },
          });
          if (data[0].deadline) {
            this.setState({
              datePickerValue: moment(data[0].deadline),
              // datePickerValue:  moment(UTCTimeFormat(data[0].deadline.substring(0,data[0].deadline.length-4), true))
            });
          }
          if (data[0].cDocID) {
            store.collaborationStore.setThisCDocId(data[0].cDocID);
          }
          resolve(data[0]);
        } else {
          if (res.message === 'REVIEWSESSIONID_IS_NOT_EXIST') {
            res.message = intl.get('collaboration.Dlg.FileNotExist');
          }
          store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: res.message });
        }
      });
    });
  };
  getOperandsLog = () => {
    const { perPage, currentPage } = this.state.logSendData;
    const { reviewSessionID } = this.props.data || this.state.propsData.data;
    const sendData = { perPage, currentPage, reviewSessionID };
    store.collaborationStore.getShareReviewOperandsLog(sendData).then((res) => {
      const { ret, data } = res;
      if (ret === 0) {
        const { list } = data;
        let activeList = list.map((item) => {
          return {
            name: item.userName,
            createDate: item.startTime,
            ...item,
          };
        });
        if (currentPage !== 1) {
          activeList = this.state.activeList.concat(activeList);
        }
        this.setState({ activeList, logLoading: false });
        if (list.length < perPage) {
          this.setState({ logHasMore: false });
        }
      } else {
        store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: res.message });
      }
    });
  };
  loadMore = () => {
    const sendData = { ...this.state.logSendData };
    sendData.currentPage++;
    if (!this.state.logHasMore) return;
    this.setState(
      {
        logSendData: { ...sendData },
        logLoading: true,
      },
      () => {
        this.getOperandsLog();
      },
    );
  };
  setDeadline = (deadline) => {
    const sendData = { deadline };
    this.putShareView(
      sendData,
      () => {
        store.userStore.doSendGAEventByUserEvent(ADD_DEADLINE_SUCCESS, null, null);
        const fileDetails = { ...this.state.fileDetails };
        fileDetails.deadline = deadline;
        this.setState({
          fileDetails: { ...fileDetails },
          openDatePicker: false,
        });
        this.getFileDetails().then((data) => {
          if (this.props.icon) store.collaborationStore.setDeadline(data.deadlineSeconds);
        });
      },
      () => {
        store.userStore.doSendGAEventByUserEvent(ADD_DEADLINE_FAILED, null, null);
      },
    );
  };
  showModel = (type) => {
    const baseText = 'collaboration.sharedList.SharedTableAction';
    const title = `${baseText}.${isFromReader() ? 'ConfirmModalTitleOnReader' : 'ConfirmModalTitle'}`;
    const textMap = {
      Delete: {
        content: `该文档将从共享列表中移除。您想要继续吗？`,
        contentTitle: `确定移除？`,
        confirmText: `确定`,
        confirm: this.deleteSharedFile,
      },
      Unshared: {
        content: '该文档将停止共享。您想要继续吗？',
        contentTitle: `确定取消共享？`,
        confirmText: `确定`,
        confirm: this.unsharedFile,
      },
      RemoveMe: {
        content: `如果您将自己移除了，该文件将从您的共享文件列表中删除。`,
        contentTitle: `确定移除我？`,
        confirmText: `确定`,
        confirm: this.removeMe,
      },
      UnsharedDeleteFile: {
        content: `该文档将从共享列表中移除。您想要继续吗？`,
        contentTitle: `确定移除？`,
        confirmText: `确定`,
        confirm: this.removeMe,
      },
    };
    const { content, confirmText, confirm, contentTitle } = textMap[type];

    this.setState({
      showModel: true,
      modelDateils: {
        title: intl.get(title),
        content,
        confirmText,
        cancelText: intl.get(`${baseText}.modelCancelBtnText`),
        confirm,
        contentTitle,
        cancel: this.hideModel,
      },
    });
    let parent = this.props.parentCom;
    if (parent === 'CollaborationHeader') {
      if (type === 'Unshared') {
        store.userStore.doSendGAEvent({ eventKey: UNSHARE_FILE, label: 'review_mode_upper_right_area' });
      }
      if (type === 'Delete') {
        store.userStore.doSendGAEvent({ eventKey: DELETE_SHARED_FILE, label: 'review_mode_upper_right_area' });
      }
    } else if (parent === 'SharedTable' || parent === 'Thumbnail') {
      if (type === 'Unshared') {
        store.userStore.doSendGAEvent({ eventKey: UNSHARE_FILE, label: 'getting_started' });
      }
      if (type === 'Delete') {
        store.userStore.doSendGAEvent({ eventKey: DELETE_SHARED_FILE, label: 'getting_started' });
      }
    }
  };
  hideModel = (e) => {
    e.stopPropagation();
    this.setState({ showModel: false });
  };
  unsharedFile = () => {
    // if (store.appStore.isIncludeFoxitStorage) {
    //   return this.unsharedFileInStorage();
    // }
    this.putShareView(
      { shareState: 1 },
      () => {
        this.updateTableList();
        collaborationService.showCommonModeSidebar();

        store.appStore.backToHomeStart('normal');

        store.userStore.doSendGAEventByUserEvent(UNSHARE_FILE_SUCCESS, null, null);
      },
      () => {
        store.userStore.doSendGAEventByUserEvent(UNSHARE_FILE_FAILED, null, null);
      },
    );
  };
  unsharedFileInStorage = (password) => {
    const propsData = this.props.data || this.state.propsData.data;
    collaborationService.unshare(propsData.reviewSessionID, password).then(
      (data) => {
        if (data.ret === 900006) {
          // 密码错误
          return store.storageAppStore.promptPassword(password).then((newPwd) => {
            return this.unsharedFileInStorage(newPwd);
          });
        }
        store.storageAppStore.updateStorageSpaceSize();
        this.updateTableList();
        collaborationService.showCommonModeSidebar();
        store.appStore.backToHomeStart('normal');
        store.userStore.doSendGAEventByUserEvent(UNSHARE_FILE_SUCCESS, null, null);
      },
      () => {
        store.userStore.doSendGAEventByUserEvent(UNSHARE_FILE_FAILED, null, null);
      },
    );
  };
  deleteSharedFile = () => {
    this.putShareView(
      { delFlag: 1 },
      () => {
        this.updateTableList('maintain');
        store.userStore.doSendGAEventByUserEvent(DELETE_SHARED_FILE_SUCCESS, null, null);
      },
      () => {
        store.userStore.doSendGAEventByUserEvent(DELETE_SHARED_FILE_FAILED, null, null);
      },
    );
  };
  putShareView = (data, success, error) => {
    const propsData = this.props.data || this.state.propsData.data;
    const sendData = {
      reviewSessionID: propsData.reviewSessionID,
      ...data,
    };
    this.setState({ logLoading: true });
    store.collaborationStore.putShareReview(sendData).then((res) => {
      const { ret } = res;
      this.setState({ logLoading: false });
      if (ret === 0) {
        success && success(res);
      } else {
        error && error(res);
      }
    });
  };
  removeMe = () => {
    const propsData = this.props.data || this.state.propsData.data;
    const sendData = {
      isJoin: 0,
      reviewSessionID: propsData.reviewSessionID,
    };
    this.setState({ logLoading: true });
    store.collaborationStore.shareReviewParticipant(sendData).then((res) => {
      if (res.ret == 0) {
        this.setState({ logLoading: false });
        this.updateTableList('init');
        store.userStore.doSendGAEventByUserEvent(REMOVE_ME_SUCCESS, null, null);
      } else {
        store.userStore.doSendGAEventByUserEvent(REMOVE_ME_FAILED, null, null);
      }
    });
    store.userStore.doSendGAEvent({ eventKey: REMOVE_ME, label: 'getting_started' });
  };
  copyLink = () => {
    if (store.appStore.isDisableButton(SHARE_DOC)) return;
    let parent = this.props.parentCom;
    if (parent === 'CollaborationHeader') {
      store.userStore.doSendGAEvent({ eventKey: COPY_SHARED_LINK, label: 'review_mode_upper_right_area' });
    }
    if (parent === 'SharedTable' || parent === 'Thumbnail') {
      if (store.collaborationStore.shareReviewListParams.source == '1') {
        store.userStore.doSendGAEvent({ eventKey: COPY_SHARED_LINK_BY_OTHERS, label: 'getting_started' });
      } else {
        store.userStore.doSendGAEvent({ eventKey: COPY_SHARED_LINK_BY_YOU, label: 'getting_started' });
      }
    }

    const data = this.props.data || this.state.propsData.data;
    const { fileLink, reviewSessionID, docName } = data;
    const link = `${location.origin}/?docUrl=${encodeURIComponent(fileLink)}&fileName=${encodeURIComponent(docName)}&reviewSessionID=${reviewSessionID}`;
    copyToClipboard(
      link,
      () => {
        store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.Dlg.CopySuccessful') });
        store.userStore.doSendGAEventByUserEvent(COPY_SHARED_LINK_SUCCESS, null, null);
      },
      () => {
        store.userStore.doSendGAEventByUserEvent(COPY_SHARED_LINK_FAILED, null, null);
      },
    );
  };
  updateTableList = (type) => {
    const { updateTableList } = this.props;
    this.closePop(false);
    updateTableList && updateTableList(type);
  };
  downloadFile = () => {
    const data = this.props.data || this.state.propsData.data;
    const {
      //  reviewSessionID,
      fileLink,
      //  docName
    } = data;
    window.location.href = fileLink;
    // const sendData = {
    //   confText: {
    //     listnewUrl: `reviewSessionID=${reviewSessionID}&getYourself=1&lastTime=0000-00-00%2000%3A00%3A00%3A000&pageObjNum=-1`,
    //   },
    //   documents: [{ url: fileLink }],
    //   filename: docName,
    // };
    // this.setState({ logLoading: true });
    // store.collaborationStore.downloadFile(sendData).then((url) => {
    //   if (url) {
    //     const { platform } = store.appStore;
    //     if (platform === 'PhantomOnline') {
    //       window.location.href = url;
    //     } else if (platform === 'Phantom' || isFromReader()) {
    //       store.collaborationStore.postDownloadFileLink({ url });
    //     }
    //     this.setState({ logLoading: false }, () => {
    //       store.userStore.doSendGAEventByUserEvent(DOWNLOAD_FILE_SUCCESS, null, null);
    //     });
    //   } else {
    //     store.userStore.doSendGAEventByUserEvent(DOWNLOAD_FILE_FAILED, null, null);
    //   }
    // });
    // store.userStore.doSendGAEvent({ eventKey: DOWNLOAD_FILE, label: 'getting_started' });
  };
  getInviteParams(isDingtalk) {
    const propsData = this.props.fileLink ? this.props : this.state.propsData;
    const { fileLink, cDocID, reviewSessionID, docName } = propsData;
    const data = { fileLink, cDocID, reviewSessionID };
    if (isDingtalk) {
      data.docName = docName;
    }
    return data;
  }
  addSuccess = () => {
    const { reviewSessionID } = store.collaborationStore.shareReviewData;
    if (this.props.parentCom === 'CollaborationHeader') {
      store.collaborationStore.queryShareViewData({ reviewSessionID, getMore: 1 });
    }
    if (this.props.parentCom === 'SharedTable' && this.props.getShareReviewList) {
      this.props.getShareReviewList();
    }
  };
  add = ({ /* AllowComment, */ /* emailList, options, */ selectEmailList, /* email */ message }) => {
    this.setState({ isLoading: true });
    const { fileLink, cDocID, reviewSessionID } = this.getInviteParams();

    const newselectEmailList = selectEmailList.map((item) => {
      item.prohibitComment = item.AllowComment ? 0 : 1;
      delete item.AllowComment;
      return item;
    });

    const sendData = { cDocID, reviewSessionID, userEmail: newselectEmailList, fileLink, message };
    store.collaborationStore.inviteJoin(sendData).then(
      (res) => {
        const { ret, data } = res;
        if (ret === 0) {
          this.addSuccess();
          store.userStore.doSendGAEventByUserEvent(ADD_MORE_PEOPLE_SUCCESS, null, null);
          store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.sharedList.SharedTableAction.sendSuccessful') });
        } else {
          if (ret === 110015) {
            store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.Error.limitOnInvite', { limitNum: data[0].limitUserCount }) });
          } else {
            store.appStore.setGlobalMessage({ type: 'error', content: res.message });
          }

          store.userStore.doSendGAEventByUserEvent(ADD_MORE_PEOPLE_FAILED, null, null);
          store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.sharedList.SharedTableAction.sendFailed') });
        }
        this.setState({ isLoading: false });
      },
      () => {
        store.appStore.setGlobalMessage({ type: 'success', content: intl.get('collaboration.sharedList.SharedTableAction.sendFailed') });
      },
    );
  };
  componentDidUpdate() {
    const { notPhantomOnline, isolateComponent } = this.state;

    if (notPhantomOnline && isolateComponent && this.containerRef) {
      const targetNode = this.containerRef;

      if (targetNode) {
        setTimeout(() => {
          store.collaborationStore.postWinSizeMsg({ name: 'SharedTableAction', width: targetNode.clientWidth, height: targetNode.clientHeight });
        }, 500);
      }
    }
  }
  render() {
    // let isBlack = getQueryVariable('isBlack') == 1;
    // let icon = isBlack ? acitonIconBlack : acitonIcon;
    const {
      visible,
      // notPhantomOnline,
      isolateComponent,
      popover_zIndex,
    } = this.state;
    // const img = this.props.icon || icon;
    return (
      <ConfigProvider locale={zhCN}>
        {!isolateComponent && (
          <Popover
            arrowPointAtCenter
            zIndex={popover_zIndex}
            /* getPopupContainer={triggerNode => triggerNode.parentNode}  */
            overlayClassName="shareTableActionPopover"
            content={this.getContent()}
            placement="bottomRight"
            trigger="click"
            visible={visible}
            onVisibleChange={this.closePop}>
            <i className={`action-icon ${visible ? 'visible' : ''}`} alt="" />
          </Popover>
        )}
        {/* {notPhantomOnline && isolateComponent && (
          <div ref={this.saveContainerRef} className={`SharedTableActionDialog `}>
            {this.getContent()}
          </div>
        )} */}
      </ConfigProvider>
    );
  }
}
